import React from 'react';
import BarButtonFw, { BUTTON_DEFAULT } from '../../../framework/bar-button/BarButtonFw';
import GridFw from '../../../framework/grid/GridFw';
import { BasePage } from '../../../framework/pages/BasePage';
import { ModalContext } from '../../../provider/ModalProvider';

export class ParametrosCadenaModal extends BasePage {
  static contextType = ModalContext;

  createPageProperties = (pageApi) => {
    return {
      title: 'Visualización de Parámetros',
    };
  }

  renderPage(pageApi) {
    const { hideModal } = this.context;

    const barHeaderConfig = {
      fields: [
        { ...BUTTON_DEFAULT.RETURN, onClick: () => hideModal() }
      ]
    }

    const gridConfig = {
      rowId: 'id_rel_ss_muestras_cotizacion',
      showIndex: false,
      autoLoad: true,
      pagination: true,
      load: {
        queryId: 881,
        params: () => {
          return {
            id_muestreo: pageApi?.name?.id_muestreo
          }
        },
        hideMessage: true,
        hideMessageError: true,
      },
      fields: [
        { name: 'parametro', label: 'Parámetro' },
        { name: 'subparametro', maxVisible: 2, label: 'Sub Parámetros' },
      ]
    };

    return (
      <>
        <GridFw
          name="parametrosGrid"
          getParentApi={pageApi.getApi}
          config={gridConfig}
        />
        <BarButtonFw
          name="agregarButton"
          getParentApi={pageApi.getApi}
          config={barHeaderConfig}
        />
      </>
    )
  }
}
